/**
 * Pumper (third-party quantity-break widget) runs inside #svelte-bundle-widget.
 * The app often hides native radios (display:none / tabindex=-1), which removes them
 * from the tab order. This patch restores keyboard access and names the form for SRs.
 * ACC-023: tier compare + sale amounts get <del>/<ins> + .sr-only labels (matches PDP).
 */
(function () {
  var WIDGET = '#svelte-bundle-widget';

  function getPriceLabels() {
    var L = window.pumperA11yLabels || {};
    return {
      regular: L.priceRegular || 'Regular price',
      sale: L.priceSale || 'Sale price',
    };
  }

  function escapeRe(s) {
    return String(s).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  function pumperPriceVisible(el) {
    if (!el) return false;
    if (el.getAttribute('aria-hidden') === 'true') return false;
    var st = window.getComputedStyle(el);
    if (st.display === 'none' || st.visibility === 'hidden') return false;
    return el.getClientRects().length > 0;
  }

  function normalizePriceText(el, noiseLabels) {
    var t = el.textContent.replace(/\s+/g, ' ').trim();
    (noiseLabels || []).forEach(function (l) {
      if (!l) return;
      t = t.replace(new RegExp(escapeRe(l), 'gi'), ' ');
    });
    return t.replace(/\s+/g, ' ').trim();
  }

  function stripDelMarkup(compareEl, regularLabel) {
    if (!compareEl || compareEl.getAttribute('data-a11y-pumper-del') !== '1') return;
    var raw = normalizePriceText(compareEl, [regularLabel]);
    compareEl.textContent = raw;
    compareEl.removeAttribute('data-a11y-pumper-del');
    compareEl.removeAttribute('data-a11y-pumper-price');
  }

  function stripInsMarkup(mainEl, labels) {
    if (!mainEl || mainEl.getAttribute('data-a11y-pumper-ins') !== '1') return;
    var raw = normalizePriceText(mainEl, [labels.sale, labels.regular]);
    mainEl.textContent = raw;
    mainEl.removeAttribute('data-a11y-pumper-ins');
    mainEl.removeAttribute('data-a11y-pumper-price');
  }

  function patchCompareDel(el, regularLabel) {
    if (!el || !pumperPriceVisible(el)) return;
    var raw = normalizePriceText(el, [regularLabel]);
    if (!raw || !/\d/.test(raw)) return;

    var first = el.firstElementChild;
    if (
      first &&
      first.tagName === 'DEL' &&
      el.getAttribute('data-a11y-pumper-price') === raw
    ) {
      return;
    }

    el.textContent = '';
    var del = document.createElement('del');
    var sr = document.createElement('span');
    sr.className = 'sr-only';
    sr.textContent = regularLabel;
    del.appendChild(sr);
    del.appendChild(document.createTextNode(raw.indexOf('$') === 0 ? raw : ' ' + raw));
    el.appendChild(del);
    el.setAttribute('data-a11y-pumper-price', raw);
    el.setAttribute('data-a11y-pumper-del', '1');
  }

  function patchMainIns(el, saleLabel, regularLabel) {
    if (!el || !pumperPriceVisible(el)) return;
    var raw = normalizePriceText(el, [saleLabel, regularLabel]);
    if (!raw || !/\d/.test(raw)) return;

    var first = el.firstElementChild;
    if (
      first &&
      first.tagName === 'INS' &&
      el.getAttribute('data-a11y-pumper-price') === raw
    ) {
      return;
    }

    el.textContent = '';
    var ins = document.createElement('ins');
    var sr = document.createElement('span');
    sr.className = 'sr-only';
    sr.textContent = saleLabel;
    ins.appendChild(sr);
    ins.appendChild(document.createTextNode(raw.indexOf('$') === 0 ? raw : ' ' + raw));
    el.appendChild(ins);
    el.setAttribute('data-a11y-pumper-price', raw);
    el.setAttribute('data-a11y-pumper-ins', '1');
  }

  function patchTierPrices(root) {
    var labels = getPriceLabels();
    var wrappers = root.querySelectorAll('.tier-price, .pumper_horizontal_price_wrapper');
    if (!wrappers.length) return;

    wrappers.forEach(function (wrapper) {
      var compare = wrapper.querySelector(
        '.tier-price__compare, .pumper_horizontal_compare_price, [id^="pumper_originalAmount_"]'
      );
      var main = wrapper.querySelector(
        '.tier-price__main, .pumper_horizontal_price, [id^="pumper_totalAmount_"]'
      );

      var compareText =
        compare && pumperPriceVisible(compare)
          ? normalizePriceText(compare, [labels.regular, labels.sale])
          : '';

      if (compareText && main) {
        patchCompareDel(compare, labels.regular);
        patchMainIns(main, labels.sale, labels.regular);
      } else {
        if (compare) stripDelMarkup(compare, labels.regular);
        if (main) stripInsMarkup(main, labels);
      }
    });
  }

  function stripPumperHiddenUtilities(el) {
    // Pumper / Tailwind v4: class "pmpr:!hidden" => display:none !important (excludes from tab order)
    try {
      el.classList.remove('pmpr:!hidden');
    } catch (e) {}
  }

  /** Visually hidden but still focusable; inline !important beats app-injected stylesheets */
  function applyFocusableVisuallyHidden(el) {
    el.classList.add('pumper-a11y-input');
    el.style.setProperty('position', 'absolute', 'important');
    el.style.setProperty('width', '1px', 'important');
    el.style.setProperty('height', '1px', 'important');
    el.style.setProperty('padding', '0', 'important');
    el.style.setProperty('margin', '-1px', 'important');
    el.style.setProperty('overflow', 'hidden', 'important');
    el.style.setProperty('clip-path', 'inset(50%)', 'important');
    el.style.setProperty('clip', 'rect(0, 0, 0, 0)', 'important');
    el.style.setProperty('border', '0', 'important');
    el.style.setProperty('white-space', 'nowrap', 'important');
    el.style.setProperty('opacity', '0.01', 'important');
    el.style.setProperty('display', 'block', 'important');
    el.style.setProperty('visibility', 'visible', 'important');
    el.style.setProperty('pointer-events', 'auto', 'important');
  }

  function patchRadios(root) {
    var radios = root.querySelectorAll('input[type="radio"]');
    if (!radios.length) return false;

    radios.forEach(function (el) {
      if (el.disabled) return;

      stripPumperHiddenUtilities(el);

      if (el.getAttribute('tabindex') === '-1') {
        el.removeAttribute('tabindex');
      }
      if (el.getAttribute('aria-hidden') === 'true') {
        el.removeAttribute('aria-hidden');
      }

      applyFocusableVisuallyHidden(el);
    });

    var form =
      root.querySelector('.pmpr_layout_horizontal form') ||
      root.querySelector('#prvw_bundle form') ||
      root.querySelector('form');
    if (form) {
      var titleEl = root.querySelector('#pumper__block_title');
      if (titleEl && titleEl.id) {
        form.setAttribute('aria-labelledby', titleEl.id);
        form.removeAttribute('aria-label');
      } else if (window.pumperA11yLabels && window.pumperA11yLabels.form) {
        if (!form.getAttribute('aria-label') && !form.getAttribute('aria-labelledby')) {
          form.setAttribute('aria-label', window.pumperA11yLabels.form);
        }
      }
    }

    root.querySelectorAll('[id^="pumper_prvw__radio__botton_"]').forEach(function (decoy) {
      if (decoy.tagName !== 'INPUT' && !decoy.getAttribute('aria-hidden')) {
        decoy.setAttribute('aria-hidden', 'true');
      }
    });

    return true;
  }

  function run() {
    var root = document.querySelector(WIDGET);
    if (!root) return;
    patchRadios(root);
    patchTierPrices(root);
  }

  function observe(el, obs) {
    obs.observe(el, { childList: true, subtree: true });
    run();
  }

  var obs = new MutationObserver(function () {
    run();
  });

  var root = document.querySelector(WIDGET);
  if (root) {
    observe(root, obs);
  } else {
    var boot = new MutationObserver(function () {
      var el = document.querySelector(WIDGET);
      if (el) {
        boot.disconnect();
        observe(el, obs);
      }
    });
    boot.observe(document.documentElement, { childList: true, subtree: true });
  }
})();
